import AnnouncementList from "../components/AnnouncementList";

const ListAnnouncementPage = () => {
  return (
    <AnnouncementList />
  );
};

export default ListAnnouncementPage;
